module.exports = __webpack_public_path__ + "img/25-hornet-nav.983cea21.png";